import { gql } from '@/__generated__/gql';

export const DEAL_PIPELINE_INVESTMENT_WORKFLOW_COMPLETED_STATE_HISTORY_QUERY = gql(`
  query WorkflowInstanceStateCompletionHistory($instanceId: String!) {
    workflowInstanceStateCompletionHistory(instanceId: $instanceId) {
      createdAt
      fromState {
        name
        label
        updatedAt
      }
      toState {
        name
        label
        updatedAt
      }
    }
  }
`);

export const DEAL_PIPELINE_INVESTMENTS_QUERY = gql(`
  query DealPipelineInvestments($page: Int, $rowsPerPage: Int, $sort: String, $order: String, $statusFilter: [String!], $search: String, $quickFilter: String, $assetClassQuickFilter: String) {
    Investments(
      page: $page
      rowsPerPage: $rowsPerPage
      sort: $sort
      order: $order
      statusFilter: $statusFilter
      search: $search
      quickFilter: $quickFilter
      assetClassQuickFilter: $assetClassQuickFilter
    ) {
      total
      page
      perPage
      filters {
        name
        type
        value
        enabled
        count
      }
      data {
        id
        name
        assetClass {
          id
          name
        }
        subAssetClass {
          id
          name
        }
        managerId
        symbol
        minimum
        sri
        ubtiBlocker
        vintageYear
        custodied
        targetIRR
        targetYield
        securityStatus
        nextClose
        finalClose
        investorDocsDue
        aggregateCommitment
        aggregateInterest
        showToAllAdvisoryFirms
        tenants {
          id
          name
          type
        }
        assignee {
          id
          firstName
          lastName
        }
        availableWorkflowTransitions {
          id
          name
          label
          description
          inputSchemaName
          outputSchemaName
        }
        workflowInstance {
          id
          currentState {
            name
            label
          }
          workflowDefinition {
            id
            label
          }
        }
        createdAt
        updatedAt
        pendingCommitmentCount
        activeCommitmentCount
        pacingType
        pacingStartingQuarter
        pacingStartingYear
        dueDiligenceRecord {
          id
          status
          activeTier {
            id
            name
            funnel {
              id
              latestFunnel {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`);

export const DEAL_PIPELINE_INVESTMENT_WORKFLOW_STATE_FILTERS_QUERY = gql(`
query DealPipelineInvestmentWorkflowStateFilters {
  InvestmentWorkflowStateFilters {
      id
      name
      label
      subjectStatus
    }
  }
`);

export const DEAL_PIPELINE_PAGE_EXECUTE_WORKFLOW_TRANSITION_MUTATION = gql(`
  mutation DealPipelinePageExecuteWorkflowTransition($data: ExecuteWorkflowTransitionInput!) {
    executeWorkflowTransition(data: $data) {
      data
    }
  }
`);

export const UPDATE_INVESTMENT_SECURITY_STATUS_TRANSITION_MUTATION = gql(`
  mutation UpdateInvestmentSecurityStatusTransition($data: UpdateInvestmentSecurityStatusTransitionInput!) {
    updateInvestmentSecurityStatusTransition(data: $data) {
      fromStateId
      toStateId
      data
      inputSchemaName
      outputSchemaName
    }
}`);

export const LIST_INVESTMENT_ASSIGNEES_QUERY = gql(`
  query FatDealPipelinePageListInvestmentAssignees {
    listInvestmentAssignees {
      id
      firstName
      lastName
      initials
      email
    }
  }
`);

export const UPDATE_INVESTMENT_RESTRICTIONS_MUTATION = gql(`
  mutation FatDealPipelinePageUpdateInvestmentRestrictions($data: UpdateInvestmentRestrictionsDto!) {
    updateInvestmentRestrictions(data: $data) {
      id
    }
  }
`);

export const DELETE_INVESTMENT_MUTATION = gql(`
  mutation FatDealPipelinePageDeleteInvestment($id: String!) {
    DeleteInvestment(id: $id)
  }
`);

export const CREATE_INVESTMENT_VEHICLE_MUTATION = gql(`
  mutation FatDealPipelinePageCreateInvestmentVehicle($data: InvestmentVehicleCreateDto!) {
    createInvestmentVehicle(data: $data) {
      id
    }
  }
`);

export const UPDATE_INVESTMENT_VEHICLE_MUTATION = gql(`
  mutation FatDealPipelinePageUpdateInvestmentVehicle($data: InvestmentVehicleUpdateDto!) {
    updateInvestmentVehicle(data: $data) {
      id
    }
  }
`);

export const DELETE_INVESTMENT_VEHICLE_MUTATION = gql(`
  mutation FatDealPipelinePageDeleteInvestmentVehicle($id: String!) {
    deleteInvestmentVehicle(id: $id)
  }
`);

export const DELETE_INVESTMENT_OFFERING_MATERIALS_ATTACHMENT_MUTATION = gql(`
  mutation FatDealPipelinePageDeleteInvestmentOfferingMaterialsAttachment($id: String!) {
    deleteInvestmentOfferingMaterialsAttachment(id: $id)
  }
`);

export const INVESTMENT_VEHICLES_QUERY = gql(`
  query FatDealPipelinePageInvestmentVehicles($data: InvestmentVehiclesRequestDto!) {
    investmentVehicles(data: $data) {
      id
      investmentId
      name
      taxExempt
      hasAllocations
      hasCommitments
    }
  }
`);

export const OWNERS_QUERY = gql(`
  query FatDealPipelinePageAllocationOwners($id: String!) {
    AllocationOwners(id: $id) {
      investmentOwners {
        ...OwnersFragment
      }
      operationsOwners {
        ...OwnersFragment
      }
      complianceOwners {
        ...OwnersFragment
      }
    }
  }
`);
